/* React imports */
import React from 'react';
import ReactDOM from 'react-dom';
/* Minified Bootstrap and custom CSS (compiled from LESS on start or build) */
import './bootstrap.min.css';
import './custom.css';
/* Import app and render to index page */
import App from './App';
ReactDOM.render(<App />, document.getElementById('root'));